<!--我的订单-->
<template>
  <div class="home-main materialList">
    <div class="main" v-loading="loading">
      <div class="main_title">
        <span class="title-cn">{{ viewTitle }}</span>
        <span class="title-en">/{{ viewEnTitle }}</span>
        <div class="main-title-right">
          <el-button size="medium" v-if="isSuperUser()" class="primary"
            @click="createMaterialOpen">上传素材</el-button><el-button size="medium" class="danger"
            @click="appletShow">素材库小程序</el-button>
          <!-- class="danger" -->
        </div>
      </div>
      <!--筛选部分start-->
      <div class="myOrder-selector">
        <div class="select-item">
          <p>产品标签</p>
          <el-select v-model="searchOption.product" @change="changeProduct" placeholder="请选择" clearable>
            <el-option v-for="(item, key) in productList" :key="key" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="select-item">
          <p>内容标签</p>
          <el-select v-model="searchOption.category" placeholder="请选择" clearable>
            <el-option v-for="(item, key) in categoryList" :key="key" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- <div class="select-item">
          <p>素材类型</p>
          <el-select v-model="searchOption.type" placeholder="请选择" clearable>
            <el-option v-for="(item, key) in typeList" :key="key" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </div> -->
        <el-button size="small" class="warning" @click="search">搜索</el-button>
        <el-button size="small" @click="resetSearch">重置</el-button>
      </div>
      <!--筛选部分end-->

      <div class="myOrder-main-line"></div>

      <!--订单列表start-->
      <div class="myOrder-main-list">
        <el-table height="100%" :data="tableData" style="width: 100%;" stripe>
          <el-table-column width="40"> </el-table-column>
          <el-table-column label="产品标签" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.product }}</span>
            </template>
          </el-table-column>
          <el-table-column label="内容标签" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.category }}</span>
            </template>
          </el-table-column>
          <el-table-column label="素材类型" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.type }}</span>
            </template>
          </el-table-column>
          <el-table-column label="素材标题">
            <template slot-scope="scope">
              <span>{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="素材文案">
            <template slot-scope="scope">
              <span>{{ scope.row.content }}</span>
            </template>
          </el-table-column>
          <el-table-column label="文件名">
            <template slot-scope="scope">
              <span>{{ scope.row.filename }}</span>
            </template>
          </el-table-column>
          <el-table-column label="公开发布" v-if="isSuperUser()" width="80">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.valid" @change="changeValid($event, scope.row)">
              </el-switch>
            </template>
          </el-table-column>

          <el-table-column label="最后更新时间" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.update_time }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="editMaterial(scope.$index, scope.row)"
                v-if="isSuperUser()">编辑</el-button>
              <el-button size="mini" type="primary" @click="downLoadMaterial(scope.$index, scope.row)">下载</el-button>
              <el-button size="mini" type="primary" v-if="isSuperUser()"
                @click="deleteMaterialData(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--订单列表end-->
      <div class="pagination">
        <el-pagination :disabled="!pagination.use" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[20, 30, 50, 100]" :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>

      <el-dialog :title="dialogTitle" :visible.sync="materialDialog" width="510px" class="editCustomerDialog">
        <!-- <img :src="certificateUrl" alt="" width="100%" /> -->
        <el-form ref="ruleForm" :model="materialForm" :rules="formRules" label-width="80px">
          <el-form-item label="产品线" prop="product">
            <el-select v-model="materialForm.product" placeholder="请选择" @change="uploadChangeProduct">
              <el-option v-for="(item, key) in productList" :key="key" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场景标签" prop="scenario">
            <el-select v-model="materialForm.scenario" placeholder="请选择" @change="scenarioChangeHandle">
              <el-option v-for="(item, key) in scenarioList" :key="key" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="内容标签" prop="category">
            <el-select v-model="materialForm.category" placeholder="请选择">
              <el-option v-for="(item, key) in categoryList" :key="key" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="cwshow" label="财务系统" prop="caiwuxitong">
            <el-select v-model="materialForm.caiwuxitong" placeholder="请选择">
              <el-option v-for="(item, key) in caiwuxitongList" :key="key" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ywshow" label="业务系统" prop="yiwuxitong">
            <el-select v-model="materialForm.yiwuxitong" placeholder="请选择">
              <el-option v-for="(item, key) in yiwuxitongList" :key="key" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="素材类型" prop="type">
            <el-select v-model="materialForm.type" placeholder="请选择">
              <el-option v-for="(item, key) in typeList" :key="key" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="素材标题" prop="title">
            <el-input v-model="materialForm.title" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="素材文案" prop="content">
            <el-input v-model="materialForm.content" placeholder="请输入" type="textarea"
              style="white-space: pre-wrap;word-break: break-all;" rows="4"></el-input>
          </el-form-item>
          <el-form-item label="素材文件" class="meterial-upload">
            <el-upload name="file" :headers="headers" :action="uploadPath" :show-file-list="true"
              :on-success="uploadSuccess" :on-error="uploadError" :file-list="fileList" :on-change="handleChange"
              :on-remove="handleRemove">
              <el-button size="small" type="primary">点此上传</el-button>
            </el-upload>
            <!-- <span>{{ materialForm.filename }}</span> -->
          </el-form-item>
          <el-form-item label="公开发布">
            <el-switch v-model="materialForm.valid"> </el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="justify-content: flex-end;">
          <el-button class="primary" @click="save('ruleForm')">保存</el-button>
          <el-button @click="hide">取消</el-button>

        </div>
      </el-dialog>

      <el-dialog :title="appletDialogTitle" :visible.sync="appletDialog" width="560px" class="editCustomerDialog">
        <div class="applet-main">
          <div class="applet-content">
            <span>天智素材小程序中提供了丰富的宣传海报和素材，10秒钟即可生成带有</span>
            <span>自己公司名称和联系方式的专属海报，并附带海报中产品或方案的介绍</span>
            <span>文案，助力营销和服务人员，可以快速、高效的挖掘商机线索。</span>
          </div>
          <div class="applet-qrcode">
            <img src="../../assets/images/applet.jpg" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <span class="down-qrcode" @click="downQrcode">下载二维码</span>
          <el-button @click="appletHide">关闭</el-button>
        </div>
      </el-dialog>
    </div>

    <!--产品加点弹窗start-->
    <!-- <el-dialog title="订单详细" :visible.sync="rowDetailDialog" width="600px">
      <el-table :data="rowDetail" border style="width: 100%">
        <el-table-column
          v-for="(item, key) in rowDetailConfig"
          :key="key"
          :prop="key"
          :label="item"
        >
        </el-table-column>
      </el-table>
    </el-dialog> -->
    <!--产品加点弹窗end-->
  </div>
</template>

<script>
import {
  updateMaterial,
  deleteMaterial,
  readMaterial,
  createMaterial,
  getMaterialByParam,
} from "@/api/material";
import { createGetUrlParams } from "@/utils/url";
let qrcodeImage = require('@/assets/images/applet.jpg')
export default {
  data() {
    return {
      /*筛选条件-产品start*/
      uploadPath: process.env.VUE_APP_BASE_API + "/attachement/",
      severPath: process.env.VUE_APP_BASE_URL,
      fileName: "",
      viewTitle: "小程序素材",
      viewEnTitle: "Material Management",
      formRules: {
        product: [
          { required: true, message: "请选择产品线", trigger: "change" },
        ],
        category: [
          { required: true, message: "请选择内容标签", trigger: "change" },
        ],
        scenario: [
          { required: true, message: "请选择场景标签", trigger: "change" },
        ],
        // type: [
        //   { required: true, message: "请选择活动区域", trigger: "change" },
        // ],
        title: [{ required: true, message: "请输入素材标题", trigger: "blur" }],
        content: [
          { required: true, message: "请输入素材内容", trigger: "blur" },
        ],
      },
      appletDialogTitle: "素材库小程序",
      loading: false,
      pagination: {
        use: true,
        total: 0,
        size: 20,
        currentPage: 1,
      },
      mode: "add", // 模式
      dialogTitle: "上传素材",
      // 素材
      materialForm: {
        product: "", // 产品类别
        category: "", //内容标签
        type: "朋友圈推广", //素材类型
        title: "", // 素材标题
        content: "", // 素材文案
        image: "", // 文件
        valid: false, // 公开发布
        filename: "", // 文件名称
        scenario: "",   //场景
        caiwuxitong: "",   //财务系统
        yiwuxitong: "",   //业务系统
      },
      linkageList: [
        "报表工具",
        "大屏看板",
        "BI分析",
        "数据推送",
        "数据治理",
        "FastBI",
      ],

      // 筛选条件
      searchOption: {
        product: "",
        type: "",
        category: "",
      },

      // 产品类别列表
      productList: [
        {
          name: "FastBI",
          value: "FastBI",
        },
        {
          name: "安捷云",
          value: "安捷云",
        },
      ],
      // 内容标签
      categoryList: [
      ],
      cwshow: true,
      ywshow: true,
      cwContentList: [
        {
          name: "用友好会计",
          value: "用友好会计",
        },
        {
          name: "用友好业财",
          value: "用友好业财",
        },
        {
          name: "用友T+",
          value: "用友T+",
        },
        {
          name: "用友U8+",
          value: "用友U8+",
        },
        {
          name: "用友U8Cloud",
          value: "用友U8Cloud",
        },
        {
          name: "用友U9Cloud",
          value: "用友U9Cloud",
        },
        {
          name: "用友YonSuite",
          value: "用友YonSuite",
        },
        {
          name: "用友NCCloud",
          value: "用友NCCloud",
        },
        {
          name: "金蝶精斗云",
          value: "金蝶精斗云",
        },
        {
          name: "金蝶KIS云",
          value: "金蝶KIS云",
        },
        {
          name: "金蝶云星辰",
          value: "金蝶云星辰",
        },
        {
          name: "金蝶云星空",
          value: "金蝶云星空",
        },
      ],
      afDict: {
        "场景标签": [
          {
            name: "产品",
            value: "产品",
          },
          {
            name: "三大平台对接",
            value: "三大平台对接",
          },
          {
            name: "电商系统对接",
            value: "电商系统对接",
          },
        ],
        "产品": {
          "内容标签": [
            {
              name: "产品介绍",
              value: "产品介绍",
            },
            {
              name: "核心功能",
              value: "核心功能",
            },
            {
              name: "场景价值",
              value: "场景价值",
            },
            {
              name: "客户案例",
              value: "客户案例",
            },
          ],
          "业务系统": [],
          "财务系统": []

        },
        "三大平台对接": {
          "内容标签": [
            {
              name: "用户痛点",
              value: "用户痛点",
            },
            {
              name: "解决方案",
              value: "解决方案",
            },
            {
              name: "方案价值",
              value: "方案价值",
            },
            {
              name: "客户案例",
              value: "客户案例",
            },
          ],
          "业务系统": [
            {
              name: "企微OA审批",
              value: "企微OA审批",
            },
            {
              name: "钉钉OA审批",
              value: "钉钉OA审批",
            },
            {
              name: "飞书OA审批",
              value: "飞书OA审批",
            },
          ],
          // "财务系统": this.cwContentList,

        },
        "电商系统对接": {
          "内容标签": [
            {
              name: "用户痛点",
              value: "用户痛点",
            },
            {
              name: "解决方案",
              value: "解决方案",
            },
            {
              name: "方案价值",
              value: "方案价值",
            },
            {
              name: "客户案例",
              value: "客户案例",
            },
          ],
          "业务系统": [
            {
              name: "旺店通",
              value: "旺店通",
            },
            {
              name: "聚水潭",
              value: "聚水潭",
            },
            {
              name: "万里牛",
              value: "万里牛",
            },
            {
              name: "吉客云",
              value: "吉客云",
            },
            {
              name: "领星",
              value: "领星",
            },
          ],
          // "财务系统": cwContentList,

        },
      },
      fastbiDict: {
        "场景标签": [
          {
            name: "产品功能",
            value: "产品功能",
          },
          {
            name: "应用场景",
            value: "应用场景",
          },
          {
            name: "方案价值",
            value: "方案价值",
          },
          {
            name: "客户案例",
            value: "客户案例",
          },
        ],
        "产品功能": [
          {
            name: "BI分析",
            value: "BI分析",
          },
          {
            name: "电子表格",
            value: "电子表格",
          },
          {
            name: "数据整合",
            value: "数据整合",
          },
          {
            name: "数据填报",
            value: "数据填报",
          },
          {
            name: "AI问数",
            value: "AI问数",
          },
          {
            name: "数据推送",
            value: "数据推送",
          },
          {
            name: "邮件调度",
            value: "邮件调度",
          },
        ],
        "应用场景": [
          {
            name: "合并报表",
            value: "合并报表",
          },
          {
            name: "财务分析",
            value: "财务分析",
          },
          {
            name: "销售分析",
            value: "销售分析",
          },
          {
            name: "采购分析",
            value: "采购分析",
          },
          {
            name: "生产分析",
            value: "生产分析",
          },
          {
            name: "预算分析",
            value: "预算分析",
          }
        ],
        "方案价值": [
          {
            name: "报表自动化",
            value: "报表自动化",
          },
          {
            name: "数据可视化",
            value: "数据可视化",
          },
          {
            name: "治理与整合",
            value: "治理与整合",
          },
          {
            name: "集成与推送",
            value: "集成与推送",
          },
        ],
        "客户案例": [
          {
            name: "生产制造",
            value: "生产制造",
          },
          {
            name: "商贸零售",
            value: "商贸零售",
          },
          {
            name: "健康服务",
            value: "健康服务",
          },
          {
            name: "工程建设",
            value: "工程建设",
          },
          {
            name: "应用服务",
            value: "应用服务",
          },
          {
            name: "电信通信",
            value: "电信通信",
          },
          {
            name: "医疗医药",
            value: "医疗医药",
          },
          {
            name: "文化教育",
            value: "文化教育",
          },
          {
            name: "餐饮酒店",
            value: "餐饮酒店",
          },
          {
            name: "电子商务",
            value: "电子商务",
          },
          {
            name: "其他",
            value: "其他",
          }
        ],
      },
      caiwuxitongList: [

      ],
      yiwuxitongList: [

      ],
      scenarioList: [

      ],




      /*表格数据start*/
      tableData: [],
      /*表格数据end*/
      materialDialog: false,
      appletDialog: false,
      editId: null,
      fileList: [],
    };
  },
  // required
  // require()
  mounted() {
    // console.log(this.$store.getters.userInfo.is_superuser);
    this.getMaterialData();
    if (!this.isSuperUser()) {
      this.viewTitle = "小程序素材";
    } else {
      this.viewTitle = "小程序素材";
    }
  },
  methods: {
    changeProduct(val) {
    },
    handleChange(file, fileList) {
      this.fileList = [fileList[fileList.length - 1]];
    },
    handleRemove() {
      this.materialForm.image = "";
      this.materialForm.filename = "";
    },
    changeValid(valid, row) {
      let obj = {};
      for (const key in this.materialForm) {
        obj[key] = row[key];
      }
      console.log(obj);
      updateMaterial(obj, row.id)
        .then((res) => {
          this.$message.success("修改成功");
          this.getMaterialData();
        })
        .catch((err) => { });
    },
    productChange(val) {
      if (val == "FastBI") {
        this.scenarioList = this.fastbiDict['场景标签']
        this.cwshow = false;
        this.ywshow = false

      } else if (val == "安捷云") {
        this.scenarioList = this.afDict['场景标签']
        this.cwshow = true;
        this.ywshow = true
      }
    },
    uploadChangeProduct(val) {
      this.scenarioList = []
      this.yiwuxitongList = []
      this.caiwuxitongList = []
      this.categoryList = []
      this.materialForm.scenario = ""
      this.materialForm.caiwuxitong = ""
      this.materialForm.yiwuxitong = ""
      this.materialForm.category = ""
      this.productChange(val)

    },
    scenarioChange(val) {
      if (this.materialForm.product == 'FastBI') {
        this.categoryList = this.fastbiDict[val]
      } else if (this.materialForm.product == '安捷云') {
        this.categoryList = this.afDict[val]['内容标签']
        this.caiwuxitongList = this.cwContentList
        this.yiwuxitongList = this.afDict[val]['业务系统']
        if (val == "产品") {
          this.cwshow = false
          this.ywshow = false
        } else {
          this.cwshow = true
          this.ywshow = true
        }

      }
    },
    scenarioChangeHandle(val) {
      this.yiwuxitongList = []
      this.caiwuxitongList = []
      this.categoryList = []
      this.materialForm.caiwuxitong = ""
      this.materialForm.yiwuxitong = ""
      this.materialForm.category = ""
      this.scenarioChange(val)
    },
    // 上传成功
    uploadSuccess(res, file) {
      this.$message({
        type: "success",
        message: "上传成功",
      });
      this.materialForm.image = res.file;
      this.materialForm.filename = file.name;
      this.fileName = file.name;
    },
    // 上传失败
    uploadError() {
      this.$message.error("上传失败");
    },
    // 删除
    deleteMaterialData(index, row) {
      deleteMaterial(row.id)
        .then((res) => {
          this.$message.success("删除素材成功");
          this.getMaterialData();
        })
        .catch((err) => {
          this.$message.error("删除素材失败");
        });
    },
    // 编辑
    editMaterial(index, row) {
      this.editId = row.id;
      let obj = {};
      for (const key in this.materialForm) {
        obj[key] = row[key];
      }
      this.materialForm = obj;
      this.productChange(this.materialForm.product)
      this.scenarioChange(this.materialForm.scenario)

      if (obj.image) {
        this.fileList = [{ name: obj.filename, url: obj.image }];
      }
      this.mode = "edit";
      this.dialogTitle = "编辑素材";
      this.materialDialog = true;
    },
    // 下载
    downLoadMaterial(index, row) {
      if (row.image) {
        // let path = this.severPath.replace("/api/rest", () => {
        //   return "";
        // });
        let url = `${row.image}`;
        // TAG
        this.download(url, "素材");
      } else {
        this.$message.error("没有文件");
      }
    },
    downQrcode() {
      this.download(qrcodeImage, "素材小程序");
    },
    download(url, name) {
      var a = document.createElement("a");
      var event = new MouseEvent("click");
      a.download = name;
      a.href = url;
      a.dispatchEvent(event);
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getMaterialData();
    },
    handleSizeChange(val) {
      if (val <= this.pagination.total) {
        this.pagination.size = val;
        this.getMaterialData();
      }
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let fun = this.mode == "add" ? createMaterial : updateMaterial;
          this.materialForm.type = "朋友圈推广"
          console.log(this.materialForm)
          fun(this.materialForm, this.editId)
            .then((res) => {
              let message =
                this.mode == "add" ? "上传素材成功" : "编辑素材成功";
              this.$message.success(message);
              this.getMaterialData();
              this.hide();
            })
            .catch((err) => {
              let message =
                this.mode == "add" ? "上传素材失败" : "编辑素材失败";
              this.$message.error(message);
            });
        } else {
          return false;
        }
      });
    },

    //
    appletHide() {
      this.appletDialog = false;
    },

    appletShow() {
      this.appletDialog = true;
    },

    // 取消
    hide() {
      this.materialDialog = false;
      this.fileName = "";
      this.fileList = [];
      this.materialForm = {
        product: "", // 产品类别
        category: "", //内容标签
        type: "", //素材类型
        title: "", // 素材标题
        content: "", // 素材文案
        image: "", // 文件
        valid: false, // 公开发布
        filename: "", // 文件名称
        scenario: "",   //场景
        caiwuxitong: "",   //财务系统
        yiwuxitong: "",   //业务系统
      };
      this.editId = null;
    },
    // 上传素材
    createMaterialOpen() {
      // console.log(this.$ref,"this.$refs")
      // this.$ref.ruleForm.resetFields()
      this.materialForm = {
        product: "", // 产品类别
        category: "", //内容标签
        type: "", //素材类型
        title: "", // 素材标题
        content: "", // 素材文案
        image: "", // 文件
        valid: false, // 公开发布
        filename: "", // 文件名称
        scenario: "",   //场景
        caiwuxitong: "",   //财务系统
        yiwuxitong: "",   //业务系统
      };
      this.materialDialog = true;
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields()
      this.mode = "add";
      this.dialogTitle = "上传素材";
    },
    getMaterialData() {
      this.loading = true;
      let params = {
        p: this.pagination.currentPage,
        count: this.pagination.size,
      };
      Object.assign(params, this.searchOption);
      let result = createGetUrlParams(params);
      if (result.success) {
        getMaterialByParam(result.data)
          .then((response) => {
            this.loading = false;
            //  权限过滤
            let results = response.results;
            // if (!this.isSuperUser()) {
            // results = results.filter((item) => {
            //     if (item.valid) return item;
            // });
            // console.log(results);

            this.pagination.total = response.count || 0;
            this.tableData = results;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    search() {
      let params = this.searchOption;
      let result = createGetUrlParams(params);
      if (result.success) {
        this.loading = true;
        getMaterialByParam(result.data)
          .then((response) => {
            let results = response.results;
            // if (!this.isSuperUser()) {
            //   results = results.map((item) => {
            //     if (item.valid) return item;
            //   });
            // }
            this.pagination.total = response.count || 0;
            this.tableData = results;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
        this.restPage(true);
      }
    },
    resetSearch() {
      this.restPage(true);
      this.searchOption = {
        product: "",
        content: "",
        category: "",
      };
      this.getMaterialData();
    },
    restPage(isUsePagination) {
      this.pagination.use = isUsePagination;
      this.pagination.currentPage = 1;
      this.pagination.size = 20;
    },
    isSuperUser() {
      // console.log(this.$store.getters.userInfo.agent_info);
      if (this.$store.getters.userInfo.is_superuser) return this.$store.getters.userInfo.is_superuser
      // 判断是不是运营管理
      let agent_info = this.$store.getters.userInfo.agent_info;
      if (agent_info && agent_info.roles) {
        let roles = agent_info.roles;

        if (!Array.isArray(roles)) {
          roles = JSON.parse(roles)
        }
        if (roles.includes('operator')) {
          return true
        }
      }
      return false
    },
  },
  computed: {
    headers() {
      return {
        Authorization: `token ${this.$store.getters.token}`,
      };
    },
  },
};
</script>

<style lang="scss">
/*筛选部分start*/
.materialList {
  .main {
    display: flex;
    flex-direction: column;
    margin: 0px 14px;
    height: 100%;
    //background-color: #FFFFFF;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;

    .main_title {
      margin: 15px 0;
    }

    .myOrder-main-list {
      flex-grow: 1;
    }

    .main-title-right {
      float: right !important;
      width: 270px !important;
      height: 66px !important;
      line-height: 66px !important;
    }

    .applet-content {
      span {
        margin-bottom: 5px;
      }
    }

    .applet-qrcode {
      text-align: center;
      margin-top: 20px;
    }

    .el-dialog__body {
      padding: 20px;
    }

    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .meterial-upload {
    .el-form-item__content {
      display: flex;
    }

    .el-button {
      border: 0px !important;
      background-color: rgba(64, 158, 255, 0) !important;
    }

    .el-button {
      border: 0px !important;
      background-color: rgba(64, 158, 255, 0) !important;
    }

    .el-button span {
      color: #0090ee !important;
      font-size: 14px;
    }
  }

  .myOrder-main-list .cell .el-button {
    border: 0px !important;
    background-color: rgba(64, 158, 255, 0) !important;
  }

  .myOrder-main-list .cell .el-button {
    margin-left: 0px !important;
    padding: 2px 5px !important;
  }

  .myOrder-main-list .cell .el-button span {
    color: #0090ee !important;
  }
}

.down-qrcode {
  color: #1425da;
  cursor: pointer;
}

.myOrder-selector {
  padding: 18px 0px 20px 24px !important;
  min-width: 980px !important;
  font-size: 12px !important;
  height: 32px !important;
  background: #fff;
}

.select-item {
  float: left !important;
  margin-right: 34px !important;
}

.select-item .el-date-editor {
  width: 180px !important;
}

.select-item .el-input__inner {
  padding-right: 0px !important;
}

.select-item p {
  padding-right: 10px !important;
  float: left !important;
  height: 32px !important;
  line-height: 32px !important;
  text-align: right !important;
}

.select-input {
  float: left !important;
  width: 180px !important;
}

.select-item .el-select {
  width: 200px !important;
}

.select-item .el-select .el-input__inner {
  height: 32px;
  line-height: 32px;
}

.select-item .el-select {
  .el-input__suffix {
    top: 5px;
  }

  .el-input__icon {
    line-height: inherit;
  }

  .el-input__suffix-inner {
    display: inline-block;
  }
}

.el-select-dropdown__list {
  padding: 6px 0px 22px 0px !important;
}

.el-select-dropdown span {
  font-size: 12px !important;
}

/*筛选部分end*/

.myOrder-main-line {
  width: 100% !important;
  border-bottom: 1px solid #ededed !important;
}

/*订单列表start*/
.myOrder-main-list {
  min-width: 1100px !important;
  height: 430px;
  /*margin-top: 10px!important;*/
  /*margin:35px 30px 0px 30px!important;*/
}

.myOrder-main-list .cell span {
  font-size: 12px !important;
}

/*订单列表end*/
</style>



// WEBPACK FOOTER //
// src/components/material/materialList.vue